import React from 'react';
import TabPanel, { FormTabs } from './components/TabPanel';
import BasicInfoTab from './components/BasicInfoTab';
import SalaryInfoTab from './components/SalaryInfoTab';
import { useStaffForm } from './hooks/useStaffForm';
import Modal from '../Modal';
import WorkInfoTab from './components/WorkInfotab';

export default function AddEditStaffModal({ open, onClose, isEdit, data }) {
    const {
        activeTab,
        handleTabChange,
        actions,
        modalTitle,
        formProps,
        // useState
        loading,
        stateProps,
        // functions
        getShiftfromHubId,
        getZonesFromHubId,
        fetchHubListWithFilters,
        fetchBusinessList,
    } = useStaffForm({ open, onClose, isEdit, data });

    return (
        <Modal
            onClose={onClose}
            open={open}
            title={modalTitle}
            actions={actions}
            stickyActions={true}
            maxWidth={'md'}
            withBackDrop={true}
            loading={loading}
            containerStyle={{ padding: 0, height: '75vh' }}
        >
            <FormTabs
                activeTab={activeTab}
                handleTabChange={handleTabChange}
                formProps={formProps}
            >
                <FormTabs.Tab title={'Basic Info'} />
                <FormTabs.Tab
                    title={'Work Info'}
                    // disabled={!state?.hubId}
                />
                <FormTabs.Tab
                    title={'Salary Info'}
                    // disabled={isSalaryInfoTabDisabled}
                />
            </FormTabs>
            <TabPanel value={activeTab} index={0}>
                <BasicInfoTab {...formProps} {...stateProps} />
            </TabPanel>
            <TabPanel value={activeTab} index={1}>
                <WorkInfoTab
                    {...{
                        isEdit,
                        ...formProps,
                        // useState
                        ...stateProps,
                        // functions
                        getShiftfromHubId,
                        getZonesFromHubId,
                        fetchHubListWithFilters,
                        fetchBusinessList,
                    }}
                />
            </TabPanel>
            <TabPanel value={activeTab} index={2}>
                <SalaryInfoTab
                    {...{
                        ...formProps,
                        // useState
                        ...stateProps,
                        isEdit,
                    }}
                />
            </TabPanel>
        </Modal>
    );
}
